

import { defineComponent, PropType } from 'vue';
import { RecordData } from '@/hooks/report.hooks';
import uiTitleVue from './uiTitle.vue';

export default defineComponent({
  components: {
    uiTitleVue,
  },
  props: {
    data: Array as PropType<RecordData[]>,
  },
  setup() {
    return {
    };
  },
});
